import styled from 'styled-components'

export const DemandStyle = styled.div`
  margin: 140px 0 140px 0;
  display: flex;
  padding: 20px 0;
  position: relative;
  > img {
    position: absolute;
    z-index: -1;
    width: 100%;
    display: block;
    left: 0;
    right: 0;
    bottom: -30px;
  }
  .column-bottom {
    margin-bottom: 60px;
  }
  .top-margin {
    margin-top: 20px;
  }
  .bottom-margin {
    margin-bottom: 20px;
  }

  .scroll {
    .scroll-col {
      margin-bottom: 20px;
    }
  }
  @media screen and (min-width: 300px) and (max-width: 1116px) {
    margin: 60px 0 60px 0;
    background: linear-gradient(to top, #e8dce1, rgba(227, 239, 249, 0));
    .scroll-row {
      overflow-x: scroll;
      overflow-y: hidden;
      white-space: nowrap;
      display: block;
      -webkit-overflow-scrolling: touch;
      .scroll-col {
        height: 100%;
        flex-basis: 70%;
        max-width: 70%;
        margin-right: 15px;
        display: inline-flex;
        vertical-align: top;
        border-radius: 20px;
        margin-bottom: 0;
      }
    }
    .title.top {
      display: none;
    }
    .card-image-box {
      padding: 15px 0;
      height: 100%;
      min-width: 220px;
    }

    .card-image {
      padding: 15px 0 !important;
    }
    .card-image-box .text .desc {
      display: block;
      white-space: normal;
    }
    .card-image-box .text {
      border-top: solid 1px #dddddd;
      height: 308px;
      padding: 20px;
    }
    > img {
      display: none;
    }
  }
`

export const ListCleanStyle = styled.div`
  .title-service {
    font-size: 18px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #888888;
    display: flex;
    text-align: center;
    width: 100%;
    margin-bottom: 20px;
  }
  .list {
    display: flex;
    margin: 10px 0;
    width: 100%;
    flex-direction: column;
    &-row {
      display: flex;
      margin: 8px 0;
      width: 100%;
      align-items: center;
      flex-direction: row;
      .check {
        display: flex;
        width: 30px;
        height: 30px;
        margin-right: 10px;
        img.check {
          display: block;
          padding: 0;
          width: 100%;
        }
      }
      span {
        font-family: 'Open sans', sans-serif;
        font-size: 18px;
        font-weight: normal;
        font-style: normal;
        font-stretch: normal;
        line-height: normal;
        letter-spacing: normal;
        color: #333333;
      }
    }
  }
`
